import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Configuration from "src/config/configuration";
import NetworkWithToken from "../../../config/networkwithtoken";
import NetworkRequest from "../../../config/network";
import {
  apiResponseInitialState,
  apiresponseType,
  getConvertedParams,
  getParametersHeaderPost,
} from "src/config/helper";
import { TENANT } from "src/utils/constant";

export const fetchCourseDetailsById = createAsyncThunk(
  "courseDetails",
  async (id: { userId: any; courseId: any; isAuth: boolean }) => {
    try {
      if (id?.isAuth) {
        const response = await NetworkWithToken.get(
          getConvertedParams(Configuration.apis.getCourseById, id),
        );
        if (response.status) {
          const resulData = response?.data;
          return resulData;
        }
      } else {
        const response = await NetworkRequest.get(
          getConvertedParams(Configuration.apis.getCourseById, id),
          getParametersHeaderPost({ tenantId: TENANT }),
        );
        if (response.status) {
          const resulData = response?.data;
          return resulData;
        }
      }
    } catch (err) {
      console.log(err);
    }
  },
);

interface courseDetailsState {
  courseDetails: apiresponseType;
  loading: boolean;
  error: any;
}

const initialState = {
  courseDetails: apiResponseInitialState,
  loading: false,
  error: {},
} satisfies courseDetailsState as courseDetailsState;

const courseDetailsSlice = createSlice({
  name: "getCourseById",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCourseDetailsById.pending, (state, action) => {
        state.loading = true;
        state.error = "";
        state.courseDetails = apiResponseInitialState;
      })
      .addCase(fetchCourseDetailsById.fulfilled, (state, action) => {
        state.loading = false;
        state.error = "";
        state.courseDetails = action.payload;
      })
      .addCase(fetchCourseDetailsById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.courseDetails = apiResponseInitialState;
      });
  },
});

export default courseDetailsSlice.reducer;
